export const ERROR = 1
export const FETCH_COMPLETED = 2
export const PUSH_COMPLETED = 3
export const DELETE_COMPLETED = 4
export const UPDATE_COMPLETED = 5
export const SET_CURRENT_TYPE = 6
export const SET_HISTORY = 7
export const SET_CURRENT_ITEM = 8
export const SET_SHOW_EDIT_RECEIVER = 9
export const SUB_ERROR = 12

export const RECEIVER_CLEAR = 13
export const UPDATE_FIELDS = 14